module.exports = __webpack_public_path__ + "media/join_room.b924344e.mp3";